export default {
    FOOD: 'food',
    GLASS: 'glass',
    PAPER: 'paper',
    MESSAGE: 'message',
    FOLDER: 'folder'
};
